import React from 'react';
import { motion } from 'framer-motion';
import { SiDotnet, SiAngular, SiMicrosoftsqlserver } from 'react-icons/si';
import { RiSparklingFill } from 'react-icons/ri';

import { AppWrap } from '../../wrapper';
import { images } from '../../constants/';
import './Header.css';

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: 'easeInOut',
    },
  },
};

// The stack Sahas actually builds on day to day.
const STACK = [
  { id: 'dotnet', label: '.NET', Icon: SiDotnet, color: '#512BD4' },
  { id: 'ai', label: 'Applied AI', Icon: RiSparklingFill, color: '#1A73E8' },
  { id: 'angular', label: 'Angular', Icon: SiAngular, color: '#DD0031' },
  { id: 'sqlserver', label: 'SQL Server', Icon: SiMicrosoftsqlserver, color: '#CC2927' },
];

const Header = () => (
  <div className="app__header app__flex">
    <motion.div
      whileInView={{ x: [-100, 0], opacity: [0, 1] }}
      transition={{ duration: 0.5 }}
      className="app__header-info"
    >
      <div className="app__header-badge">
        <div className="badge-cmp app__flex">
          <span>👋</span>
          <div style={{ marginLeft: 20 }}>
            <p className="p-text">HI, I am</p>
            <h1 className="head-text">Sahas</h1>
          </div>
        </div>

        <div className="tag-cmp app__flex">
          <p className="p-text">Software Engineer</p>
          <p className="p-text">Enterprise Systems &amp; AI Projects</p>
        </div>
      </div>
    </motion.div>

    <motion.div
      whileInView={{ opacity: [0, 1] }}
      transition={{ duration: 0.5, delayChildren: 0.5 }}
      className="app__header-img"
    >
      <img src={images.profile} alt="Sahas Belbase" />
      <motion.img
        whileInView={{ scale: [0, 1] }}
        transition={{ duration: 1, ease: 'easeInOut' }}
        src={images.circle}
        alt=""
        className="overlay_circle"
      />
    </motion.div>

    <motion.div
      variants={scaleVariants}
      whileInView={scaleVariants.whileInView}
      className="app__header-circles"
    >
      {STACK.map(({ id, label, Icon, color }) => (
        <div className="circle-cmp app__flex" key={id} title={label} aria-label={label}>
          <Icon style={{ color }} />
        </div>
      ))}
    </motion.div>
  </div>
);

export default AppWrap(Header, 'home');
